import { SortingRule } from 'react-table';
import getSortingParamsFromURL from 'components/v2/DataTable/helpers/getSortingParamsFromURL';
import type { DataTableURLParamKeys } from 'components/v2/DataTable/data/urlParams';

const getInitialSorting = (
  defaultSortBy: SortingRule<string>[] | undefined,
  sortableColumnIds: string[],
  urlParamKeys?: Pick<DataTableURLParamKeys, 'sortId' | 'sorting'>,
  search?: string
): SortingRule<string>[] => {
  const sortParamsFromURL = getSortingParamsFromURL(urlParamKeys, search);
  if (
    sortParamsFromURL.id &&
    sortableColumnIds.includes(sortParamsFromURL.id)
  ) {
    return [sortParamsFromURL];
  }

  if (defaultSortBy) {
    return defaultSortBy;
  }

  return [];
};

export default getInitialSorting;
